<template>
  <div class="shootings" :class="{active: !loading}" v-images-loaded:on.progress="imageProgress">
    <transition name="fade">
      <Loading :progress="progress" v-if="loading"/>
    </transition>
    <router-link v-for="({ title, slug, date, acf_shooting }) in l" :key="slug" :to="`/shooting/${slug}`" tag="div" class="link">
      <div class="img">
        <img :src="acf_shooting.thumbnailShooting.sourceUrl" :srcset="acf_shooting.thumbnailShooting.srcSet" :alt="acf_shooting.thumbnailShooting.altText">
        <div class="meta">
          <h2>{{ title }}</h2>
          <span>{{ date | dateFormat }}</span>
        </div>
      </div>
    </router-link>
    <div class="more" v-if="links && l.length <= links.length" @click="maxToShow = maxToShow + 10">
      <p>More Shootings</p>
    </div>
  </div>
</template>

<script>
import { ALL_SHOOTINGS } from '../queries'
import { useQuery, useResult } from '@vue/apollo-composable'

import { ref, computed } from '@vue/composition-api'

import Loading from '../components/Loading'

import { useImageLoading } from '../compositions/useImageLoading'

export default {
  name: 'categories',
  components: {
    Loading,
  },
  head: {
    title: {
      inner: 'Shootings'
    },
  },
  setup() {
    const { result } = useQuery(ALL_SHOOTINGS, {number: 100})
    const links = useResult(result, null, data => data.posts.nodes)

    const [ progress, loading, imageProgress ] = useImageLoading()

    const maxToShow = ref(10);

    const l = computed(() => links.value ? links.value.slice(0, maxToShow.value): false)

    return {
      links,
      loading,
      progress,
      imageProgress,
      maxToShow,
      l
    }
  }
}
</script>

<style lang="scss" scoped>
  .shootings {
    @extend %container;
  }

  .link {
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 50vh;
    margin: 25vh 0;
  }

  .img {
    position: relative;
    height: 100%;
    max-width: 100%;
    opacity: 0;
    transition: opacity 0.8s $ease-out;

    .active & {
      opacity: 1;
    }

    &:hover {
      &:after {
        background-color: rgba($white, 0.3);
        transform: translate3d(-4px, 4px, 0);
      }

      img {
        box-shadow: 0 0 20px 4px rgba($black, 0);
        transform: translate3d(-4px, 4px, 0);
      }

      h2 {
        color: $black;
      }

      span {
        color: $black;
      }
    }

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($white, 0.6);
      transition: background-color 0.8s $ease-out, transform 0.8s $ease-out;
    }

    img {
      height: 100%;
      max-width: 100%;
      object-fit: cover;
      box-shadow: -4px 4px 15px 4px rgba($black, 0.15);
      transition: box-shadow 0.8s $ease-out, transform 0.8s $ease-out;
    }

  }

  .meta {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1;
    transform: translate3d(1rem, -1rem, 0);
    opacity: 0;
    transition: opacity 0.8s 0.4s $ease-out;

    .active & {
      opacity: 1;
    }
  }

  h2 {
    @extend %font-bold;
    @extend %link;

    font-size: 2rem;
    line-height: 2rem;
    letter-spacing: 0.5em;
    text-shadow: 0 0 20px rgba($white, 0.2);
    white-space: nowrap;
    transition: letter-spacing 1s 0.4s $ease-out, color 0.8s $ease-out;

    @media screen and (max-width: $tablet){
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .active & {
      letter-spacing: 0;
    }
  }

  span {
    @extend %font-regular;
    @extend %link;

    display: block;
    font-size: 0.6rem;
    line-height: 0.6rem;
    letter-spacing: 1rem;
    text-shadow: 0 0 20px rgba($white, 0.2);
    white-space: nowrap;
    transition: letter-spacing 1s 0.4s $ease-out, color 0.8s $ease-out;

    .active & {
      letter-spacing: 0.5em;
    }
  }

  .more {
    text-align: center;

    p {
      @extend %font-bold;
      @extend %link;

      cursor: pointer;
      font-size: 2rem;
      line-height: 2.5rem;
    }
  }
</style>